import addScript from '../addScript';
import { STATIC_PATH } from '../../../constants';

const addMathJax = async (targetWindow) => {
  const mathJaxConfig = `window.MathJax = {
    options: {
      renderActions: {
        addMenu: [],
        checkLoading: []
      }
    }
  };`;

  await addScript(
    targetWindow.document,
    { id: 'mathjax-config' },
    mathJaxConfig,
  );

  await addScript(targetWindow.document, {
    src: `${STATIC_PATH}/js/MathJax-3.2.0/es5/tex-mml-chtml.js`,
  });

  if (!targetWindow?.MathJax?.startup?.promise) {
    // Wait for the MathJax script to initialize. It is usually instantaneous, but may not be.
    // Or the CDN may fail to load.
    try {
      let intervalId;
      let timeoutId;
      await new Promise((resolve, reject) => {
        intervalId = setInterval(() => {
          if (Boolean(targetWindow?.MathJax?.startup?.promise)) {
            clearInterval(intervalId);
            clearTimeout(timeoutId);
            resolve();
          }
        }, 100);
        timeoutId = setTimeout(() => {
          clearInterval(intervalId);
          reject();
        }, 10000);
      });
    } catch (_) {
      console.warn(
        'Failed to load or initialize MathJax. Timed out after 10s.',
      );
      return;
    }
  }

  await targetWindow.MathJax.startup.promise;
};

export default addMathJax;
